<h2>Fases</h2>

<div class="tds-row">
  <app-button text="Criar fase" (clicked)="create()"></app-button>
</div>

<app-table
  [headers]="headers"
  [content]="faseList"
  [showFilter]="true"
  [hasEdit]="true"
  [hasDelete]="true"
  (editing)="edit($event)"
  (deleting)="confirmDelete($event)"
>
</app-table>
